import { ReactNode, ReactElement, useState } from 'react';
import Pagination from '@mui/material/Pagination';
import styled from '@emotion/styled';
import { gray01, primary, white } from 'presentations/views/styles/color';

export interface Props {
  currentPage: number;
  numberOfPages: number;
  onChange?: any;
}

export default function Component(props: Props) {
  const numberOfPages = Number(props.numberOfPages);
  if (numberOfPages <= 1) return null;
  return (
    <Styled
      page={Number(props.currentPage)}
      count={Number(props.numberOfPages)}
      onChange={props.onChange}
    />
  );
}

const Styled = styled(Pagination)`
  button {
    color: ${primary};
    &.Mui-selected {
      color: ${gray01};
    }
    :hover {
      background-color: ${white};
    }
  }
`;
